import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { isNullOrEmpty } from '../../core/utils/common-functions';

export const KB = { level: 'KB', unit: 1024 };
export const MB = { level: 'MB', unit: 1024 * KB.unit };
export const GB = { level: 'GB', unit: 1024 * MB.unit };

@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(value: any, ...args: any[]): any {
    let target: any = null;
    let displayVal = value;
    for (const unit of [KB, MB, GB]) {
      const tmpValue = this.calculateDisplayLevel(value, unit);
      if (tmpValue < 1) {
        if (unit === KB) {
          displayVal = Math.ceil(tmpValue);
          target = unit;
        }
        break;
      }
      displayVal = Math.ceil(tmpValue);
      target = unit;
    }

    return isNullOrEmpty(target)
      ? value
      : `${this.decimalPipe.transform(displayVal, '1.0-0')} ${target.level}`;
  }

  private calculateDisplayLevel(size: number, unitInfo: any): number {
    const value = size / unitInfo.unit;
    return value;
  }
}
